export default __webpack_public_path__ + "static/case-39dfae52b0107dbb8f945b2bbddb3868.png";